module.exports = __webpack_public_path__ + "static/img/2.9c12139.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/2.png
// module id = PZmA
// module chunks = 0